import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-market" }
const _hoisted_2 = {
  key: 0,
  class: "page-space-50"
}
const _hoisted_3 = { class: "container-small" }
const _hoisted_4 = { class: "flex-mobile justify-content-space-between align-items-center" }
const _hoisted_5 = { class: "s5_mobile" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "s10_mobile container-full-2" }
const _hoisted_8 = { class: "search-view-input-set" }
const _hoisted_9 = { class: "s5_mobile" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  style: {"height":"300px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_12 = {
  key: 1,
  class: "grid-web4"
}
const _hoisted_13 = {
  key: 2,
  style: {"height":"300px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_14 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }

import axios from 'axios';
import { onMounted, reactive, ref, toRaw } from 'vue';
import { useRouter } from 'vue-router';
import MarketCardProduct from './components/MarketCardProduct.vue';
import { useMarketCartStore } from '@/stores/cart.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProduitsView',
  setup(__props) {

const router = useRouter();
const layout = ref('none');
const loading = ref(false);
const errorMessage = ref('');
const startupInfos = reactive({
    categories: [] as any[],
});
const itemsList = ref([] as any[]);
const queryParams = reactive({
    pageNumber: 1,
    sorting: null as string | null,
    search: '',
    market_categorie_id: null as number | null,
});
const pagination = reactive({
    total: 0,
    per_page: 16,
    last_page: 1
});
const SORT_OPTIONS = [
    { value: 'nom_asc', label: 'Nom (ASC)', sort_column: 'nom', sort_direction: 'ASC' },
    { value: 'nom_desc', label: 'Nom (DESC)', sort_column: 'nom', sort_direction: 'DESC' },
    { value: 'created_at_asc', label: 'Date (ASC)', sort_column: 'created_at', sort_direction: 'ASC' },
    { value: 'created_at_desc', label: 'Date (DESC)', sort_column: 'created_at', sort_direction: 'DESC' },
];

onMounted(() => {
    if (router.currentRoute.value.query.categorie && !isNaN(Number(router.currentRoute.value.query.categorie))) {
        queryParams.market_categorie_id = Number(router.currentRoute.value.query.categorie);
    }
    layout.value = router.currentRoute.value.meta.layout as string || 'none';
    doGetStartupInfos().then(() => {
        doGetProducts();
    });
});

async function doGetStartupInfos() {
    try {
        loading.value = true;
        errorMessage.value = '';
        const httpResponse = await axios.get(`/market/products_startup_infos`);
        Object.assign(startupInfos, httpResponse.data);
    } catch(error: any) {
        errorMessage.value = error.message;
    } finally {
        loading.value = false;
    }
}

async function doGetProducts() {
    try {
        loading.value = true;
        errorMessage.value = '';
        const queryParamsRaw = toRaw(queryParams);
        const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
        const httpResponse = await axios.get(`/market/products?${queryString}`);
        itemsList.value = httpResponse.data.data;
        pagination.total = httpResponse.data.total;
        pagination.per_page = httpResponse.data.per_page;
        pagination.last_page = httpResponse.data.last_page;
    } catch(error: any) {
        errorMessage.value = error.message;
    } finally {
        loading.value = false;
    }
}

function onFiltersChanged() {
    const sortItem = SORT_OPTIONS.find(o => o.value == queryParams.sorting);
    if (sortItem) {
        queryParams.pageNumber = 1;
    }
    doGetProducts();
}

function onPaginate(pageNumber: number) {
    queryParams.pageNumber = pageNumber;
    doGetProducts();
}

return (_ctx: any,_cache: any) => {
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (layout.value == 'none')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select-ghost w-100 secondary-font font-semibold",
            name: "market_categorie_id",
            id: "market_categorie_id",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.market_categorie_id) = $event)),
            onChange: onFiltersChanged
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("option", {
              value: null,
              selected: ""
            }, "Toutes les catégories", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.categories, (categorie, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: categorie.id
              }, _toDisplayString(categorie.nom), 9, _hoisted_6))
            }), 128))
          ], 544), [
            [_vModelSelect, queryParams.market_categorie_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "search-view-input",
              placeholder: "Recherche...",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.search) = $event)),
              onKeyup: _withKeys(onFiltersChanged, ["enter"])
            }, null, 544), [
              [_vModelText, queryParams.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select-ghost sm w-100 secondary-font font-semibold",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.sorting) = $event)),
            name: "filter-sort",
            id: "filter-sort",
            onChange: onFiltersChanged
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("option", { value: null }, "Trier par", -1)),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SORT_OPTIONS, (option, index) => {
              return _createElementVNode("option", {
                key: index,
                value: option.value
              }, _toDisplayString(option.label), 9, _hoisted_10)
            }), 64))
          ], 544), [
            [_vModelSelect, queryParams.sorting]
          ])
        ])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "loader dark" }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
      (!loading.value && itemsList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
              return (_openBlock(), _createBlock(MarketCardProduct, {
                key: index,
                produit: item,
                layout: layout.value
              }, null, 8, ["produit", "layout"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!loading.value && itemsList.value.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("div", { class: "text-center mt-40 mb-40" }, [
              _createElementVNode("h3", { class: "secondary-font font-semibold" }, "Aucun produit disponible")
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_custom_pagination, {
          modelValue: queryParams.pageNumber,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = ($event: any) => ((queryParams.pageNumber) = $event)),
            onPaginate
          ],
          total: pagination.total,
          "per-page": pagination.per_page,
          last_page: pagination.last_page
        }, null, 8, ["modelValue", "total", "per-page", "last_page"])
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
  ]))
}
}

})